export const reviews = [
  {
    id: 1,
    gender: "male",
    age: "30代",
    sessions: 23,
    label: "30代 · 男性 ・ 19回目",
    text: "もう10回以上リピートしています。\n最初のころはM性感ぽいプレイをお願いしていて、だんだんとSMチックなこともお願いするようになりました。\n\n私は痛くされるのが好きなので、ペ〇スに電流を流していただけませんか？とお願いしたことがあります。\n\n引かれるか不安でしたが、ニコニコで聞き入れていただき、楽しそうに電流を流してくれました。\n\n「次は尿道にプラグを刺して、内側から電流を流そうね」と笑顔で言ってくれる、変態度の高い人です。\n（もちろんやっていただきました）\n\n普通のM性感プレイも上手ですし、マニアックなプレイもいろいろと対応できる方だと思います。\n\nプレイ以外ではふわっとした雰囲気のある優しい人なので、M性感初心者の方にもおすすめです！",
  },
  {
    id: 2,
    gender: "male",
    age: "50代",
    sessions: 5,
    label: "50代 · 男性 ・ 5回目",
    text: "むぎさんと初めてお会いした時の印象は、ほわほわしていて凄く感じが良く、包み込むような暖かいオーラを放っておりました。\n\nカウンセリングを済ませプレイ開始！\nさっきまでの優しい表情はなくなり、笑顔だけど目が笑ってない...凄く冷たい目が興奮したのを覚えてます。\n\n比べてはいけないのかもしれないけど、今までアナルにペニバンを入れていただけた中で、一番気持ち良かった。\n\nむぎさんは変態指数が高いから、絶対にこんなプレイしたいて伝えたら引くようなプレイでも叶えてくれるような包容力があるように感じました。わたくしの主観なので、実際は本人に確認してくださいね。むぎさんが実直だから、こちらも素直な気持ちにさせてくれる女性です。\n\n何で様つけないのと言うと、様をつけて呼べるのは、むぎさんに認められたマゾだけだと信条なのです。",
  },
  {
    id: 3,
    gender: "female",
    age: "年齢非公開",
    sessions: 0,
    label: "年齢非公開・男性・複数回",
    text: "むぎさんとの出会いで一番衝撃的だったのは、「ペニバンが動かない！！」ということでした。もちろんマゾなのでぶちこまれてガン掘りされる良さもあります。が、むぎさんは挿入してから慣れるまでホールドしてくれ、丁度良い頃合いで丁度良いところを突いてくれるのです。\n\nそんなSEX巧者のイケメンみたいなペギング、生まれて初めてでした。体感上の動きは激しくないのに、後で動画を見たらしっかりあの国宝級のお尻をぶるっぶるに振って突いてくださってるように見えたのも達人の業（わざ）という感じです。当然の話ですが手マンもクソ上手いです。トびます。\n\nいきなり核心に迫るところから書いてしまいましたが、初対面の時からこちらを緊張させないような空気づくりからはじまり、プレイの運び方など色んな所に気遣いの細やかさを感じてたまに弟子入りしたくなることがあります。どんなお仕事でも成功される方だろうなという印象です。\n\nとはいえマゾに合わせるだけでなく、むぎさんご自身が積極的に「やりたいこと」「やって楽しいこと」を共有してくれ、それにトライさせてくれるので、毎回新たな扉を開かれる感じもあります。\n\n全頭マスクに赤ちゃんのロンパースを着るとドスケベだという発想、一体どこからきたのでしょうか。またやらせてください。\n\nいつもポジティブな気持ちになれる変態プレイを楽しませてくれるむぎさんが大好きです♥",
  },
  {
    id: 4,
    gender: "male",
    age: "30代",
    sessions: 4,
    label: "30代 · 男性・ 4回目",
    text: "プレイ前に丁寧なカウンセリングがあり、自分の身体や気持ちの状態をしっかりと把握してもらえたのが印象的でした。雰囲気も落ち着いていて、笑顔も素敵な方なので刺激的でかつしっかり癒されました。\n\nまたぜひお願いしたいと思います。",
  },
  {
    id: 8,
    gender: "male",
    age: "30代",
    sessions: 26,
    label: "30代 · 男性 ・ 26回目",
    text: "いつもお世話になっております。\n\nむぎさんはマゾやサブにとって、底なしにお優しい方です。初めてお会いしたのは約2年程前かと思います。Xやご自身のページで書いている、素敵で知的な文章に惹かれて指名しました。\n\nお会いした時の印象は「本当にS女さんですか...？」と言うような柔らかな印象でした。その時の自分は自分の癖や好きな事が分からず、しかしアブノーマルである事に苦しんでいる頃であった為、親身に寄り添って頂きプレイをさせて頂きました。\n\nもう何度お会いしたかわかりませんが、徐々に関係が構築されて、完全に犬になっております。\n\nお仕置きを受けた事も、苦手だなと思っていた事も、むぎさんなら受け入れられました。\n\nいつも首輪をつけて頂いてると思っているので、真っに生きていられます。ありがとうございます😭\n\n\n自分がレビューなど分不相応ですが、もちろんスキルも一級品です。\n\nペニパンや亀●責めでは本気で快楽地獄に堕として頂けますし、乳首もあってよかったと思ってしまう程気持ち良く舐めて頂けます。\n\n一度仕事前に伺ったら、メスイキのしすぎて、足が震えて全く仕事が出来なかった時もあります。\n\nこんなに優しいのに、怖い時は本当に怖いのも好きです。絶対勝てないと分からせられる事もあります。\n\nむぎさんはベテランなので、勿論筋金入りのマゾの方もおすすめですが、自分みたいに迷っている人に強くおすすめ致します。\n\n僕は迷い苦しみながらむぎさんの元へ流れ着いて、本当に幸せです。もし貴方が迷っているなら、きっと導いてくださると思います。",
  },
  {
    id: 6,
    gender: "female",
    age: "30代",
    sessions: 3,
    label: "30代 · 女性 ・ 3回目",
    text: "初めてお会いした時、とても綺麗な方だなと思いました。\n\n可愛いお洋服を着た素敵な女性が第一印象で、その後とってもエロい人だ！！と思ったのを今でも覚えています。\n\n初めてプレイをする前には私の好きなことを聞いてくれて安心できました。\n\nプレイの時にも私のトラウマの話や何故そう思ったか、どうしてそうなったかをきちんと話ができました。プレイの最中はとってもエッチで凄い楽しそうでした。\n\n私が知らない私に会わせてくれたり、自分でも意識してなかった好きを教えてくれたりと発見だらけ。ペニバンをつけたむぎ茶さんには凄くドキドキして、壮絶にエッチでした。\n\nそれと同時に私、これが欲しかったんだなぁという安堵にも似たような感情を持ったのも私の中では印象的でした。プレイの後も色々とお話を聞いてくれて、またお話を聞いたりと素敵な時間だったと思います。\n\nすごく綺麗で、エッチで、素敵なお姉さんのむぎ茶さん。これからも仲良くしてください。",
  },
  {
    id: 7,
    gender: "female",
    age: "30代",
    sessions: 4,
    badge: "fire",
    label: "30代 · 男性 ・ 6回目",
    text: "むぎさんの素敵なところはたくさんあります。\n\nXの投稿で、玉こんにゃくをお尻に挿れている動画をみて、自分もしてもらいたい、、、と思いお願いしました。\nすると笑いながら受け入れてくださって、買ってきた玉こんにゃくをいくつも挿れてくださいました。\n\nプレイ中のすべてが気持ちよかったのですが、ペギングがこれまでで一番気持ちよかったことを覚えています。\nゲイマッサージでも犯されているのですが、ペニバンで本物と同じくらい気持ちよくしていただいたのはむぎさんだけだと思います。\n\n何度か通わせてもらっているうちに覚えてもらえたのも嬉しかったですし、ホモ調教のご提案をくださったこともとても感謝しています。提案内容も、ぼくのことを考えてくださったことも嬉しかったです。\n\nまた文才、言語化力がとても高い方だなと思っています。\n\n日記などを読んでいると、性癖や性体験が解像度高く言語化されていて、読んでいてとても興奮します。頭の良い方に犯してもらえるのはより興奮してしまいます。書いていてお会いしたくなってきてしまいました。\n\nこれからもよろしくお願いします。",
  },
  {
    id: 5,
    gender: "male",
    age: "20代",
    sessions: 5,
    badge: "star",
    label: "20代 · 男性 ・ 初回",
    text: "優しい口調で知的な雰囲気漂う方でした。\n\nプレイ中は、しっかり反省するよう叱りつつお尻を叩いてくれ、最高の時間でした！\n\n手コキもうまく、ぜひリピしたいです。",
  },
  {
    id: 9,
    gender: "male",
    age: "40代",
    sessions: 4,
    label: "40代 ·男性 ・ ４回目",
    text: "名前は？\n〇〇\n本名？\n本名だよ。\n〇〇ー❤️〇〇ー❤️\n\n満面の笑顔で名前を叫びつつハグされてそのまま押し倒される。\n耳や首にむしゃぶりつかれる。\n柔道の寝技みたいに首と腕を極められて動けない。\nむぎさんの吐息と体重を感じる\n捕食されてるみたいで嬉しい\n指が乳輪の周囲をゆっくりと円を描くようやく乳首に到達すると、動かさずに乳首に指を置いたまま。\n優しくサワサワ\n爪でカリカリ\nおちんちんの上に脚を乗せてくれる\nむぎさんが股間を僕の脚に押してる。レザー越しだけど熱く湿っているように感じる\n乳首をぎゅっと摘み、ねっとりと舐める\n\n\n硬く勃起したおちんちんを優しく触る\n乳首でじっとりと焦らされたおちんちんは敏感になっていて繊細な刺激でも気持ちいい。包むような愛撫。射精よりも強い快感が続く。\n\nローションは人肌よりも一段高く温められているおちんちんから睾丸、会陰までじんじんと熱いおちんちんを触りながら、アナルの周囲にもローションをぬる。アナルの周囲を撫でる。会陰が気持ちいいけど早く。\n\nやっと指を入れてくれる。乳首とおちんちんで長く焦らされたアナルはすぐにきゅんきゅんする。\nおちんちんを触ったり乳首を触ったりしながら、複雑に指を動かす。\n\nむぎさん愛用のペニバン。女の子を犯すために作られたものらしい。短いディルドと長いディルドがあってまずは短いもの。\n正常位。\nゆっくり挿入してから、正座でゆっくり動く。\n痛くない？\n大丈夫\nむぎさんが覆い被さる。\n\n最初と同じように寝技みたいに首に腕を回してがっちり上半身をロックされる。\n\n僕の頬にむぎさんの頬が密着し、首には腕が絡まり、胸に体重が乗り、おちんちんに腹筋が押し水てられ、会陰にペニバンが押し付けられ、アナルがディルドに犯される。動く度にアナルから頬まで密着した全身が犯される。むぎさんの喘ぐ吐息が当たる。むぎさんの腹筋が収縮するごとにおちんちんが強く揉まれる。\n\n足をむぎさんの腰に絡ませる。女の子になれた気持ち。前立腺の奥が気持ちいい。僕の体はむぎさんに拘束されて強制的に同じリズムで律動させられる。おちんちんに当てられた筋肉の収縮がたくましい。ずっとこのまま犯されていたい。\n\n休憩\n\n4時間コースなのでまだ2時間も残っている。\n背中のフェザータッチからまた僕の体をビルドアップしていく。乳首、会陰と僕の弱いところを責める。長い方のディルドで犯してもらえるのが待ち遠しい。",
  },
];
